// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"f925ad70","94":"db35384c","193":"9dfaa8c0","212":"03f63019","453":"dab362cc","542":"1e08b3b0","698":"6e42f052","741":"f931a23e","835":"203d973e","924":"52584b3f","960":"bfc0cd54","971":"6cff557a"}[chunkId] + ".chunk.js";
};